import { render, staticRenderFns } from "./BasketMenuIcon.vue?vue&type=template&id=1f439bb0&scoped=true"
import script from "./BasketMenuIcon.vue?vue&type=script&lang=js"
export * from "./BasketMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./BasketMenuIcon.vue?vue&type=style&index=0&id=1f439bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f439bb0",
  null
  
)

export default component.exports